var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"float":"right"},on:{"click":_vm.click}},[_c('inline-svg',{staticClass:"arrow",attrs:{"fill":_vm.cor,"src":require('@/assets/icons/Arrow_chevron.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }